// import moment from 'moment';
import * as apiUtil from '../../apiUtils';
import * as apiCommon from '../../apiCommon';

function getCountedLines(stocktake, stocktakeLines) {
  const lines = [];
  (stocktakeLines || []).forEach((line) => {
    if (line.is_counted) {
      delete line.item;
      delete line.barcodes;
      delete line.qrcodes;
      delete line.status;
      lines.push(line);
    }
  });
  return lines;
}

export const saveInventoryStocktake = async (app, params) => {
  const { data, user = {} } = params;
  const linesCounted = getCountedLines(data, data.lines || []);

  let inventoryStocktake = {
    id: data.id,
    doc_type: 'inventory_stocktake',
    restart: data.restart,
    location_id: data.location_id,
    location_type: data.location_type,
    subsidiary_id: data.subsidiary_id,
    currency_id: data.currency_id,
    stocktake_type: data.stocktake_type,
    reference_id: data.reference_id,
    status_id: data.status_id,
    authorised_by: data.authorised_by,
    authorised_date: apiUtil.toUtcDate(data.authorised_date),
    start_datetime: apiUtil.toUtcDate(data.start_datetime),
    end_datetime: apiUtil.toUtcDate(data.end_datetime),
    reason_code_id: data.reason_code_id,
    comment: data.comment,
    lines: linesCounted,
    custom_fields: data.custom_fields,
  };

  let url = inventoryStocktake.doc_type;
  if (data.process) {
    url = 'inventory_stocktake/process';
  }

  return await apiCommon.saveDoc(
    app,
    {
      source: data,
      doc: inventoryStocktake,
      user,
    },
    url
  );
};

export const fetchInventoryStocktakeById = async (app, params) => {
  const { id } = params;
  const docType = 'inventory_stocktake';
  const result = apiCommon.getDoc(
    app,
    { id, docType },
    { assemble_custom_fields: true }
  );
  return result;
};

export const getItemLocation = (app, params) => {
  const { locationId, itemIds } = params;
  const query = {
    locationId: locationId,
    itemIds: itemIds,
    controlType: 'stocktake',
  };

  return apiCommon.queryDocs(app, 'inventory_stocktake/line', query);
};

export const getItemLocationById = (app, params) => {
  const { itemId, locationId } = params;

  const id = `${itemId}:${locationId}`;
  return apiCommon.getDoc(app, { id, docType: 'item_location' });
};

export const deleteInventoryStocktake = (app, data) => {
  return apiCommon.deleteDoc(app, {
    id: data.id,
    docType: 'inventory_stocktake',
  });
};
